import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { SocialService } from 'src/app/shared/services/angular-service/social.service';
import { ToastService } from 'src/app/shared/services/angular-service/toast.service';
import { LoginSignupService } from 'src/app/shared/services/node-api/login-signup.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-feed-details-component',
  templateUrl: './feed-details-component.component.html',
  styleUrls: ['./feed-details-component.component.scss'],
})
export class FeedDetailsComponentComponent implements OnInit {
  cols: any[];
  postId;
  postData: any;
  comment: string = '';
  isComment = false;
  loginEmail: any;
  user: string;
  userName: string;
  isLiked: boolean = false;
  paginationRequest = {
    field: 'updatedAt',
    order: 1,
    rows: 100,
    page: 0,
    filter: {},
    totalRecords: 0,
  };
  commentData: any;
  toRecords: number;
  actionData: any;
  userId;
  onSession: string;
  deviceType;

  constructor(
    private route: ActivatedRoute,
    private socialService: SocialService,
    private toastService: ToastService,
    private loginSignupService: LoginSignupService,
    private localStorageService: LocalStorageService,
    private cdRef: ChangeDetectorRef,
    private _location: Location
  ) {
    this.route.params.subscribe((params) => {
      this.postId = params.id;
    });
    this.userId = this.localStorageService.getItem('userId');
    this.deviceType = localStorage.getItem('deviceType')
  }

  ngOnInit(): void {
    this.loginEmail = this.loginSignupService.getUserSession()?.user?.name;
    this.user = this.localStorageService.getItem('picture')
    this.userName = this.localStorageService.getItem('name')
    this.onSession = this.localStorageService.getItem('onSession')
    this.getPostById();
    this.getLikeCount();
    this.getAllCommentData();
  }

  getLikeCount() {
    this.socialService
      .getLikeCount(this.postId)
      .then((data: any) => {
        if (data) {
          this.actionData = data;
          this.isLiked = this.actionData.likers.includes(this.userId);
        }
      })
      .catch((err: any) => {
        console.log(err);
      });

  }


  getAllCommentData() {
    let query = {
      field: this.paginationRequest.field,
      order: this.paginationRequest.order,
      rows: this.paginationRequest.rows,
      page: this.paginationRequest.page,
      filter: this.paginationRequest.filter,
      postId: this.postId,
    };
    this.socialService
      .getAllCommentData(query)
      .then((data: any) => {
        this.commentData = data.result.result;
        this.paginationRequest.totalRecords = data['totalRecords']
          ? data['totalRecords']
          : 0;
        let toRecords =
          this.paginationRequest.rows * (this.paginationRequest.page + 1);
        this.toRecords =
          this.paginationRequest.totalRecords < toRecords
            ? this.paginationRequest.totalRecords
            : toRecords;
      })
      .catch((err: any) => {
      });
  }


  isSorting = true;
  onSort(event: any) {
    this.isSorting = true;
  }

  customSort(event: any) {
    if (this.isSorting) {
      this.paginationRequest.field =
        this.cols[this.cols.findIndex((x) => x.header == event.field)].field;
      this.paginationRequest.order = event.order;
      this.getAllCommentData();
    }
  }

  //pagination
  paginate(event: any) {
    if (this.paginationRequest.page !== event.page) {
      this.paginationRequest.page = event.page;
      this.paginationRequest.rows = parseInt(event.rows);
      this.getAllCommentData();
    }
  }


  getPostById() {
    this.socialService
      .getPostById(this.postId)
      .then((data: any) => {
        this.postData = data[0];
      })
      .catch((err: any) => {
        console.log(err);
        this.toastService.addSingle(
          'error',
          'Error',
          err.message || 'Something Went wrong'
        );
      });
  }

  onComment(): boolean {
    if (this.comment.trim().length > 0) {
      return this.isComment = true
    } else {
      return this.isComment = false
    }
  }

  saveComment() {
    if(this.onSession == 'true'){
      if (this.comment.length > 240) {
        this.toastService.addSingle(
          'error',
          'Error',
          'Please enter only 240 character long Comment.'
        );
      } else {
        let document = {
          post: this.postId,
          comment: this.comment,
        }
        this.socialService
          .saveComment(document)
          .then((data: any) => {
            if (data) {
              this.actionData = data.action;
              this.isLiked = this.actionData.likers.includes(this.userId);
              this.commentData = [...this.commentData, data.comment];
              this.comment = ''
            }
          })
          .catch((err: any) => {
            console.log(err);
            this.toastService.addSingle(
              'error',
              'Error',
              err.message || 'Something Went wrong'
            );
          });
       }
    }else{
      this.toastService.addSingle(
        'error',
        'Error',
        'Please log in to your account to leave a comment.'
      );
    }
  }

  toggleLike(): void {
    if (this.isLiked) {
      this.unlikePost();
    } else {
      this.likePost();
    }
    this.cdRef.detectChanges();
  }

  likePost() {
    let UpdateDocument = {
      post: this.postId
    }
    this.socialService
      .like(UpdateDocument)
      .then((data: any) => {
        if (data) {
          this.actionData = data;
          this.isLiked = this.actionData.likers.includes(this.userId);
        }
      })
      .catch((err: any) => {
        console.log(err);
      });

  }


  unlikePost() {
    let UpdateDocument = {
      post: this.postId
    }
    this.socialService
      .unlike(UpdateDocument)
      .then((data: any) => {
        if (data) {
          this.actionData = data;
          this.isLiked = this.actionData.likers.includes(this.userId);
        }
      })
      .catch((err: any) => {
        console.log(err);
      });

  }

  goBack(event: MouseEvent) {
    event.preventDefault();  // Prevent the default anchor behavior
    this._location.back();
  }
}
